export default {
  init() {
    // JavaScript to be fired on the about us page
    console.log('arranca el elenco');

   /* let myVar;
    let myVarDos;
    $('.actorGridExte').on('click',function(){
      myVar = $(this).attr('id');
      $('#cont_' + myVar).css('display','flex');

    });

    $('.btnCerrar').on('click',function(){
      myVarDos = $(this).data('cierre');
      $('#cont_' + myVarDos).fadeOut();
    }); */




  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-elenco.js